'use strict';

var React = require('react');

var SvgFollowUpEmailMajor = function SvgFollowUpEmailMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m19.707 15.293-3-3a1.001 1.001 0 0 0-1.414 1.414l1.293 1.293h-3.586a1 1 0 0 0 0 2h3.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1c.357 0 .686.125.943.334l-9.443 5.508-9.443-5.508a1.49 1.49 0 0 1 .943-.334h17zm-18.5 12.5v-10.176l9.496 5.54a1 1 0 0 0 1.008 0l9.496-5.54v6.676h-4a6.002 6.002 0 0 0-5.917 5h-8.583a1.5 1.5 0 0 1-1.5-1.5z"
  }));
};

exports.SvgFollowUpEmailMajor = SvgFollowUpEmailMajor;
